import React, { useState } from "react";
import { Button } from "reactstrap";
import { BsFillEnvelopeFill } from "react-icons/bs";
import { GiPadlock } from "react-icons/gi";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import "./style.css";
import { useNavigate } from "react-router";
import logo from "../assets/img/logo.jpg";
import { toast } from "react-toastify";
import { postDataNoData } from "../api/method";

function Login() {
  const passwordRegExp = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$/;
  const usernameRegExp = /^[a-z0-9_-]{3,16}$/;

  const navigate = useNavigate();

  const [error, setError] = useState({});
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [passwordShown, setPasswordShown] = useState(false);

  const togglePassword = () => {
    setPasswordShown(!passwordShown);
  };

  const validation = (e) => {
    const msg = {};

    if (username === "") {
      msg.username = "Username is requied!";
    } else if (!username.match(usernameRegExp)) {
      msg.username = "Username is valid!";
    }

    if (password === "") {
      msg.password = "Password is requied!";
    } else if (!password.match(passwordRegExp)) {
      msg.password =
        "Password should be at least 6 charcters long, at least one letter and one number!";
    }

    setError(msg);
    if (Object.keys(msg).length > 0) return false;
    return true;
  };

  const handleKeyUp = () => {
    validation();
  };

  const handleSubmitLogin = async () => {
    const isValid = validation();
    const formData = new FormData();

    if (isValid) {
      formData.append("username", username);
      formData.append("password", password);

      try {
        const res = await postDataNoData("/api/Login", formData);
        toast.success("Login Success!");
        localStorage.setItem("token_key", res.data);
        localStorage.setItem("username", username);
        navigate("/admin/dashboard");
        window.location.reload();
      } catch (err) {
        console.log(err);
        toast.error("Login fail!");
        toast.error("Usename or Password Incorrect!");
      }
    }
  };

  return (
    <div className="form_login_register d-flex align-items-center justify-content-center">
      <div className="w-25 me-5">
        <img src={logo} alt="logo" width="100%" />
      </div>

      <div className="w-25">
        <h3 className="fs-1 fw-bold text-center mb-5">Login</h3>

        <div className="d-flex align-items-center line_border--nr">
          <BsFillEnvelopeFill className="fs-4 pe-1" />
          <input
            className="fs-6 border-0"
            placeholder="Username"
            type="text"
            onChange={(e) => setUsername(e.target.value)}
            onKeyUp={handleKeyUp}
          />
        </div>

        {error.username && <p className="error text-start">{error.username}</p>}

        <div className="d-flex align-items-center line_border--nr mt-2">
          <GiPadlock className="fs-4 pe-1" />
          <input
            className="fs-6 border-0"
            placeholder="Password"
            type={passwordShown ? "text" : "password"}
            onChange={(e) => setPassword(e.target.value)}
            onKeyUp={handleKeyUp}
          />
          {passwordShown === true ? (
            <AiOutlineEye
              className="fs-5 cursor_pointer"
              onClick={togglePassword}
            />
          ) : (
            <AiOutlineEyeInvisible
              className="fs-5 cursor_pointer"
              onClick={togglePassword}
            />
          )}
        </div>

        {error.password && <p className="error text-start">{error.password}</p>}

        {/* <div className="mt-4 text-center">
        Forgot you
        <a href="#" className="fw-bolder ps-1">
            Password ?
          </a>
        </div> */}

        <div className="d-flex justify-content-center">
          <Button
            className="btn_custom mt-5"
            onClick={() => handleSubmitLogin()}
          >
            Login
          </Button>
        </div>

        <div className="no_account text-center mt-4">
          Do not have an account?{" "}
          <span
            className="ms-2 cursor_pointer t-primary fw-bold"
            onClick={() => navigate("/register")}
          >
            Register
          </span>
        </div>
      </div>
    </div>
  );
}

export default Login;
